import React from "react";
import { PulseLoader } from "react-spinners";

const BtnSpinner = (props) => {
  return (
    <>
      {props.is_loading && (
        <button type="button" disabled className={props.class}>
          {props.text} &nbsp;
          {props.isfloatRight === true ? (
            <PulseLoader
              loading={props.is_loading === true}
              color={props.color}
              size={props.size}
              style={{ float: "right" }}
            />
          ) : (
            <PulseLoader
              loading={props.is_loading === true}
              color={props.color}
              size={props.size}
            />
          )}
        </button>
      )}
    </>
  );
};

export default BtnSpinner;
